export enum PropertyHouseType {
    DETACHED = 1,
    SEMI_DETACHED = 2,
    SERIAL = 3,
    WOODEN = 4
}
export enum PropertyHouseType {
    DETACHED = 1,
    SEMI_DETACHED = 2,
    SERIAL = 3,
    WOODEN = 4
}
